import { createFileRoute } from "@tanstack/react-router"
import { NotificationsPage } from "@/components/notifications-page"

export const Route = createFileRoute("/recruit/notifications")({
  component: RecruitNotificationsPage,
})

function RecruitNotificationsPage() {
  return (
    <NotificationsPage emptyCopy="Updates about applicants, messages, and your listings appear here." />
  )
}
